import { useState } from "react";
import { categories } from "@/mocks/comics";
import { useNavigate } from "react-router-dom";

export default function CategoryTabs() {
  const [activeCategory, setActiveCategory] = useState("all");
  const navigate = useNavigate();

  const handleCategoryClick = (slug: string) => {
    setActiveCategory(slug);
    navigate(`/category/${slug}`);
  };

  return (
    <section className="py-8 md:py-10 px-4 md:px-6" aria-label="漫画分类">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-4">
          <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900">
            漫画分类
          </h2>
          <a
            href="/category/all"
            className="text-sm text-primary-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line ml-1"></i>
          </a>
        </div>
        <div className="flex items-center gap-2 overflow-x-auto pb-2 scrollbar-hide flex-wrap">
          {categories.map((cat) => (
            <button
              key={cat.slug}
              onClick={() => handleCategoryClick(cat.slug)}
              className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                activeCategory === cat.slug
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-700 hover:bg-background-200"
              }`}
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className={`${cat.icon} text-sm`}></i>
              </div>
              {cat.name}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}